import React, { useEffect } from "react";
import './bootstrap.min.css'; 
import './style.css';

function Contactus() {

    useEffect(() => {
        // பக்கத்தின் தலைப்பு மற்றும் மெட்டா விவரங்களை மாற்றுதல்
        document.title = "Contact Us | Unicell Technologies Limited - Global Support";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', "Get in touch with Unicell Technologies. Contact our offices in Zambia, UK, South Africa, and USA for industrial solutions and queries.");
        }

        // Clientele Carousel-ஐ இயக்குதல்
        if (window.$ && window.$(".vendor-carousel").length > 0) {
            window.$(".vendor-carousel").owlCarousel({
                loop: true,
                margin: 45,
                autoplay: true,
                smartSpeed: 1000,
                responsive: {
                    0: { items: 2 },
                    576: { items: 4 },
                    768: { items: 6 },
                    992: { items: 8 }
                }
            });
        }
    }, []);

    return (
        <>
         <div className="container-fluid bg-primary py-5 bg-header">
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Contact Us</h1>
                    <a href="" className="h5 text-white">Home</a>
                    <i className="far fa-circle text-white px-2"></i>
                    <a href="" className="h5 text-white">Contact</a>
                </div>
            </div>
        </div>
            {/* Search Modal Start */}
            <div className="modal fade" id="searchModal" tabIndex="-1">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "rgba(9, 30, 62, .7)" }}>
                        <div className="modal-header border-0">
                            <button type="button" className="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body d-flex align-items-center justify-content-center">
                            <div className="input-group" style={{ maxWidth: "600px" }}>
                                <input type="text" className="form-control bg-transparent border-primary p-3" placeholder="Type search keyword" />
                                <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Start */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Contact Us</h5>
                        <h1 className="mb-0">If You Have Any Query, Feel Free To Contact Us</h1>
                    </div>
                    
                    <div className="row g-5 mb-5">
                        <div className="col-lg-4">
                            <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.1s">
                                <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-phone-alt text-white"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="mb-2">Call to ask any question</h5>
                                    <h6 className="text-primary mb-0">+260-978770051</h6>
                                    <h6 className="text-primary mb-0">+1-407-399-6572</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.4s">
                                <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-envelope-open text-white"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="mb-2">Email us</h5>
                                    <h6 className="text-primary mb-0">gsharma@unicellusa.com</h6>
                                    <h6 className="text-primary mb-0">info@unicellusa.com</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.8s">
                                <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-map-marker-alt text-white"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="mb-2">Our Global Offices</h5>
                                    <h6 className="text-primary mb-0">Zambia, UK, South Africa & USA</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-5">
                        <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                            <form>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input type="text" className="form-control border-0 bg-light px-4" placeholder="Your Name" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="email" className="form-control border-0 bg-light px-4" placeholder="Your Email" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-12">
                                        <input type="text" className="form-control border-0 bg-light px-4" placeholder="Subject" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-12">
                                        <textarea className="form-control border-0 bg-light px-4 py-3" rows="4" placeholder="Message"></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-primary w-100 py-3" type="submit">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                            {/* Google Map - Unicell USA Location (Example) */}
                            <iframe 
                                className="position-relative rounded w-100 h-100"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.223391312741!2d-81.379236!3d28.538335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDMyJzE4LjAiTiA4McKwMjInNDUuMiJX!5e0!3m2!1sen!2sus!4v1645000000000!5m2!1sen!2sus"
                                frameBorder="0" 
                                style={{ minHeight: "350px", border: "0" }} 
                                allowFullScreen="" 
                                aria-hidden="false"
                                tabIndex="0"
                                title="Office Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            {/* Clientele Carousel */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                    <h5 className="fw-bold text-primary text-uppercase">Our Clientele</h5>
                </div>
                <div className="container py-5 mb-5 border border-primary rounded">
                    <div className="bg-white">
                        <div className="owl-carousel vendor-carousel">
                            <img src="img/wecycle.jfif" alt="Client" />
                            <img src="img/inside.jfif" alt="Client" />
                            <img src="img/glg_logo.jfif" alt="Client" />
                            <img src="img/ZAFFICO.jpg" alt="Client" />
                            <img src="img/mantle_lab.jfif" alt="Client" />
                            <img src="img/shar.png" alt="Client" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contactus;